import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {AuthContext, useAuth} from "../contexts/AuthContext";


export default function Profile() {

    const { fetchWithAuth } = useAuth();

    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        name: user?.name || "",
        role: user?.role || "",
        username: user?.username || "",
        email: user?.email || ""
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadProfile = async () => {
            if (!user?.token) {
                navigate("/");
                return;
            }

            try {
                const data = await fetchWithAuth("/api/profile");

                setUserData({
                    name: data.name || user.name || "",
                    role: data.role || user.role || "",
                    username: data.username || user.username || "",
                    email: data.email || user.email || ""
                });
            } catch (err) {
                console.error("Failed to load profile:", err);
            } finally {
                setLoading(false);
            }
        };

        loadProfile();
    }, [user, navigate]);

    if (loading) {
        return (
            <div className="container mx-auto p-6">
                <p>Loading profile...</p>
            </div>
        );
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4">Profile</h1>
            <div className="bg-white shadow-md rounded p-4 max-w-md">
                <p className="mb-2">
                    <strong>Name:</strong> {userData.name}
                </p>
                <p className="mb-2">
                    <strong>Username:</strong> {userData.username}
                </p>
                <p className="mb-2">
                    <strong>Role:</strong> {userData.role}
                </p>
                <p className="mb-2">
                    <strong>Email:</strong> {userData.email}
                </p>
            </div>
        </div>
    );
}
